<button (click)="updateTableData()">Update table data</button>
<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
></aur-mat-table>
